var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#017EA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 27H42.3C40.22 27 38.52 28.68 38.52 30.76V32.64C38.52 34.72 40.2 36.4 42.28 36.4H51.7C53.78 36.4 55.46 34.72 55.46 32.64V30.76C55.48 28.68 53.78 27 51.7 27Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.48 32.6409C57.48 35.8209 54.88 38.4209 51.7 38.4209H42.3C39.12 38.4209 36.52 35.8209 36.52 32.6409C36.52 31.5209 35.32 30.8209 34.32 31.3409C31.5 32.8409 29.58 35.8209 29.58 39.2409V58.0609C29.58 62.9809 33.6 67.0009 38.52 67.0009H55.48C60.4 67.0009 64.42 62.9809 64.42 58.0609V39.2409C64.42 35.8209 62.5 32.8409 59.68 31.3409C58.68 30.8209 57.48 31.5209 57.48 32.6409ZM47.76 56.9009H39C38.18 56.9009 37.5 56.2209 37.5 55.4009C37.5 54.5809 38.18 53.9009 39 53.9009H47.76C48.58 53.9009 49.26 54.5809 49.26 55.4009C49.26 56.2209 48.58 56.9009 47.76 56.9009ZM53 48.9009H39C38.18 48.9009 37.5 48.2209 37.5 47.4009C37.5 46.5809 38.18 45.9009 39 45.9009H53C53.82 45.9009 54.5 46.5809 54.5 47.4009C54.5 48.2209 53.82 48.9009 53 48.9009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsIcon);
export default __webpack_public_path__ + "static/media/instructionsIcon.caf8878857cd00c3f41e5b98c8358ae0.svg";
export { ForwardRef as ReactComponent };